import Cookies from 'js-cookie';
import { all, call, put, takeEvery } from 'redux-saga/effects';

import { customerId } from 'common/helpers/tokenHelper';
import { RECORD_EVENT_REQUEST } from 'redux/analytics/constants';
import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';
import { GET_COLLECTION_SUCCESS } from 'redux/collections/constants';
import { GET_PRODUCT_TEMPLATE_SUCCESS } from 'redux/productTemplates/constants';

import { getProduct, getRelatedProducts, listProducts } from './api';
import {
  GET_PRODUCT_REQUEST,
  GET_PRODUCT_SUCCESS,
  GET_RELATED_PRODUCTS_REQUEST,
  GET_RELATED_PRODUCTS_SUCCESS,
  LIST_PRODUCTS_REQUEST,
  LIST_PRODUCTS_SUCCESS,
  PRODUCT_LIST_REQUESTING,
  PRODUCT_OBJECT_REQUESTING,
  RELATED_PRODUCTS_REQUESTING,
  RESET_PRODUCT_ISFETCHING
} from './constants';

function* list(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: PRODUCT_LIST_REQUESTING });
    const response = yield call(
      listProducts,
      action.slug,
      cartId(),
      customerId(),
      action.qString,
      action.page
    );
    yield call(listPayload, response.data);
    yield put({
      type: RECORD_EVENT_REQUEST,
      eventName: 'productList',
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_PRODUCT_ISFETCHING });

    if (error.response.status === 404 && action.onError) {
      action.onError(error);
    } else {
      yield call(addAPIError, error);
    }
  }
}

export function* listPayload(payload) {
  yield put({ type: LIST_PRODUCTS_SUCCESS, payload });
  yield put({ type: GET_COLLECTION_SUCCESS, payload });
}

function* get(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: PRODUCT_OBJECT_REQUESTING });
    const response = yield call(
      getProduct,
      action.slug,
      cartId(),
      customerId()
    );
    if (response.data.productTemplate) {
      const template = {
        id: response.data.productTemplateId || 'default',
        content: response.data.productTemplate
      };
      yield put({ type: GET_PRODUCT_TEMPLATE_SUCCESS, payload: template });
    }
    yield put({ type: GET_PRODUCT_SUCCESS, payload: response.data });
    yield put({
      type: RECORD_EVENT_REQUEST,
      eventName: 'productDetail',
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_PRODUCT_ISFETCHING });

    if (error.response.status === 404 && action.onError) {
      action.onError(error);
    } else {
      yield call(addAPIError, error);
    }
  }
}

function* getRelated(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: RELATED_PRODUCTS_REQUESTING });
    const response = yield call(
      getRelatedProducts,
      action.productId,
      action.count,
      customerId()
    );

    yield put({
      type: GET_RELATED_PRODUCTS_SUCCESS,
      payload: {
        ...response.data,
        products: response.data.products,
        mainProductId: action.productId
      }
    });
  } catch (error) {
    yield put({ type: RESET_PRODUCT_ISFETCHING });

    if (error.response?.status === 404 && action.onError) {
      action.onError(error);
    } else {
      yield call(addAPIError, error);
    }
  }
}

function* watchList() {
  yield takeEvery(LIST_PRODUCTS_REQUEST, list);
  yield takeEvery(GET_PRODUCT_REQUEST, get);
  yield takeEvery(GET_RELATED_PRODUCTS_REQUEST, getRelated);
}

export default function* productSagas() {
  yield all([watchList()]);
}

const cartId = () => Cookies.get('cartId');
